// extracted by mini-css-extract-plugin
export default {"_dm-icon--hidden":"HiddenIndicator__dm-icon--hidden__ZxSs3","aria":"HiddenIndicator_aria__uGij2"};